export default __webpack_public_path__ + "static/media/notFoundImage.1e882efe.png";